export default __webpack_public_path__ + "static/0270-78d3c580074efc7ccf0e409f1f30fc84.png";